module.exports = __webpack_public_path__ + "img/JCB.4956d635.svg";